const Storage = {
  KEY: "wownet",
}

const store = {
  local: {
    get: (name: string): any | undefined =>
      localStorage[`${Storage.KEY}.${getSessionKey()}.${name}`],
    set: (name: string, value: any) => {
      localStorage[`${Storage.KEY}.${getSessionKey()}.${name}`] = value
    },
    remove: (name: string) => {
      localStorage.removeItem(`${Storage.KEY}.${getSessionKey()}.${name}`)
    },
  },
  session: {
    get: (name: string): any | undefined =>
      sessionStorage[`${Storage.KEY}.${getSessionKey()}.${name}`],
    set: (name: string, value: any) => {
      sessionStorage[`${Storage.KEY}.${getSessionKey()}.${name}`] = value
    },
    remove: (name: string) => {
      sessionStorage.removeItem(`${Storage.KEY}.${getSessionKey()}.${name}`)
    },
  },
}

export default store

function getSessionKey() {
  const isVod = window.location.pathname.includes("/vods")

  return isVod ? "vods" : ""
}
